// Празната решетка на листа „Доставка": как се добавя продукт и клавишите.
// Не се показва, когато фактурата вече носи редове от обобщени стокови.
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { KbdChip } from "../../components/KbdChip";

export const DeliveryEmptyState = ({ isDesktop }: { isDesktop: boolean }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-2.5 px-6 py-16 text-center">
      <div className="flex h-[46px] w-[46px] items-center justify-center rounded-[13px] bg-brand-tint">
        <SearchOutlined className="text-xl text-brand-deep-ink" />
      </div>
      <div className="text-[15px] font-bold leading-[normal] text-ink">{t("inventoryPage.wsEmptyTitle")}</div>
      <div className="max-w-[480px] text-[12.5px] leading-[1.6] text-muted">{t("inventoryPage.wsEmptyHint")}</div>
      {isDesktop && (
        <div className="mt-1 flex flex-wrap items-center justify-center gap-1.5 text-xs leading-[normal] text-muted">
          <KbdChip>А–Я</KbdChip> {t("inventoryPage.wsEmptyKbdType")}
          <span className="text-ghost">·</span>
          <KbdChip>↵</KbdChip> {t("inventoryPage.wsEmptyKbdEnter")}
          <span className="text-ghost">·</span>
          <KbdChip>Esc</KbdChip> {t("inventoryPage.wsEmptyKbdEsc")}
        </div>
      )}
    </div>
  );
};

export default DeliveryEmptyState;
